import { render } from "./HrAwardTypes.vue?vue&type=template&id=78d9d46e&scoped=true"
import script from "./HrAwardTypes.vue?vue&type=script&lang=js"
export * from "./HrAwardTypes.vue?vue&type=script&lang=js"

import "./HrAwardTypes.vue?vue&type=style&index=0&id=78d9d46e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d9d46e"]])

export default __exports__